var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38969 10.9139L12.5868 2.7168C12.8758 2.42774 13.3445 2.42773 13.6336 2.71678L16.2834 5.36645C16.5725 5.65552 16.5725 6.12421 16.2834 6.41329L8.08634 14.6104C7.98828 14.7085 7.86464 14.777 7.72951 14.8082L4.8612 15.4707C4.06158 15.6554 3.34486 14.9386 3.52952 14.139L4.19187 11.2708C4.22307 11.1357 4.29162 11.012 4.38969 10.9139ZM4.50388 14.364L5.14947 11.5684L13.1102 3.60761L15.3926 5.88988L7.4319 13.8506L4.63617 14.4963C4.55677 14.5147 4.48553 14.4435 4.50388 14.364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83337 16.4998C3.55723 16.4998 3.33337 16.7237 3.33337 16.9998C3.33337 17.276 3.55723 17.4998 3.83337 17.4998H16.1667C16.4429 17.4998 16.6667 17.276 16.6667 16.9998C16.6667 16.7237 16.4429 16.4998 16.1667 16.4998H3.83337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenw);
export default __webpack_public_path__ + "static/media/Penw.d4b0a2d1d698573f11d2649eab3c87e9.svg";
export { ForwardRef as ReactComponent };